/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const manualShareAllocationSlice = createSlice({
  name: "manualShareAllocation",
  initialState: {
    // Key format: `${companyId}_${officialId}_${transactionId}`
    allocations: {},
    // Key format: `${companyId}_${officialId}_${transactionId}`
    beneficialOwnershipChanges: {},
  },
  reducers: {
    saveManualAllocation: (state, action) => {
      const { companyId, officialId, transactionId, allocationData } =
        action.payload;
      const key = `${companyId}_${officialId}_${transactionId}`;
      state.allocations[key] = {
        ...allocationData,
        timestamp: Date.now(),
      };
    },

    clearManualAllocation: (state, action) => {
      const { companyId, officialId, transactionId } = action.payload;
      const key = `${companyId}_${officialId}_${transactionId}`;
      delete state.allocations[key];
    },

    updateManualAllocation: (state, action) => {
      const { companyId, officialId, transactionId, updates } = action.payload;
      const key = `${companyId}_${officialId}_${transactionId}`;
      if (state.allocations[key]) {
        state.allocations[key] = {
          ...state.allocations[key],
          ...updates,
          timestamp: Date.now(),
        };
      }
    },

    clearAllManualAllocations: (state) => {
      state.allocations = {};
    },

    saveBeneficialOwnershipChanges: (state, action) => {
      const { companyId, officialId, transactionId, changes } = action.payload;
      const key = `${companyId}_${officialId}_${transactionId}`;
      state.beneficialOwnershipChanges[key] = {
        ...changes,
        timestamp: Date.now(),
      };
    },

    clearBeneficialOwnershipChanges: (state, action) => {
      const { companyId, officialId, transactionId } = action.payload;
      const key = `${companyId}_${officialId}_${transactionId}`;
      delete state.beneficialOwnershipChanges[key];
    },
  },
});

export const {
  saveManualAllocation,
  clearManualAllocation,
  updateManualAllocation,
  clearAllManualAllocations,
  saveBeneficialOwnershipChanges,
  clearBeneficialOwnershipChanges,
} = manualShareAllocationSlice.actions;

// Selectors
export const getManualAllocation = (
  state,
  companyId,
  officialId,
  transactionId
) => {
  const key = `${companyId}_${officialId}_${transactionId}`;
  return state.manualShareAllocationSlice?.allocations?.[key] || null;
};

export const hasManualAllocation = (
  state,
  companyId,
  officialId,
  transactionId
) => {
  const key = `${companyId}_${officialId}_${transactionId}`;
  return !!state.manualShareAllocationSlice?.allocations?.[key];
};

export const getBeneficialOwnershipChanges = (
  state,
  companyId,
  officialId,
  transactionId
) => {
  const key = `${companyId}_${officialId}_${transactionId}`;
  return (
    state.manualShareAllocationSlice?.beneficialOwnershipChanges?.[key] || null
  );
};

export default manualShareAllocationSlice.reducer;
